// Shared user-facing error copy for the target-college flows, used by both
// MyTargetColleges and TargetCollegesFullList so the wording stays in one place.
export const targetCollegeErrorMessages = {
    load: 'We couldn\'t load your target colleges. Please try again.',
    alertCooldown: 'You cannot alert this college again yet, please try again later.',
    remove: 'We couldn\'t remove that college. Please try again.',
    add: 'We couldn\'t add that college. Please try again.',
};
